/**
 * Behavior for chart accordion slice
 */
(function (Drupal, $, once) {
  Drupal.behaviors.rmccFilterAccordion = {
    attach(context, settings) {
      once('rmccFilterAccordion', '.view--header', context).forEach((elem) => {

        let $button = $('.filter--title', $(elem)),
            $panel  = $('.filter--content', $(elem));

        $button.attr( 'tabIndex', 0 );
        $panel.hide();

        // On click event.
        $button.on('click', (e) => {
          $(e.currentTarget).parent().toggleClass('open');
          $(e.currentTarget).next().slideToggle();
        });

        // On press of enter key event.
        $button.keyup(function(e) {
          if(e.keyCode == 13){
            $(e.currentTarget).parent().toggleClass('open');
            $(e.currentTarget).next().slideToggle();
          }
        });

      });

      // Accordion with checkboxes (View Events)
      if ($('.facets-checkboxes', context).length > 0 || $('.node--type-event .webform', context).length > 0) {
        const $buttonCheckbox = $('.filter--content h3, .node--type-event .webform .paragraph--title', context);

        $buttonCheckbox.on('click', e => {
          const $this = $(e.currentTarget);
          $this.toggleClass('open');
          $this.siblings('.facets-checkboxes, .node--type-event .webform--wrapper').toggleClass('hidden');
        });

        $('.view--filters__button').on('click', e => {
          const $this = $(e.currentTarget);
          $this.siblings('.view--filters__container').toggleClass('open');
        });
      }

      /*
      * Reset filters button.
      * Show button after filtering.
      * Reload page on button click.
      */
      const $originalUrl = window.location.origin + window.location.pathname;
      const $resetBtn = $('.view--filters__reset', context);

      if (window.location.href !== $originalUrl) {
        $resetBtn.addClass('show');
      }
      $resetBtn.on('click', function () {
        window.location.href = $originalUrl;
      });

      /* Auto submit radio buttons*/
      const $radioBtn = $('.view-events .form-radio', context);
      const $submitBtn = $('.view-events .bef-exposed-form .form-submit', context);

      $radioBtn.on('change', function () {
        $submitBtn.trigger('click');
      });
    }
  };
}) (Drupal, jQuery, once);